export const useIconLib = (icon: string) => {
  const dictionary =
   {
    // SVG Icons
    'Affinity':          'affinity.svg',
    'Chatbots':          'chatbot.svg',
    'Checked':           'checkbox-checked.svg',
    'Events':            'events.svg',
    'Forms':             'forms.svg',
    'Home':              'home.svg',
    'Insights':          'insights.svg',
    'Investors':         'investors.svg',
    'My Tools':          'tools.svg',
    'News':              'news.svg',
    'People':            'people.svg',
    'Onboarding':        'onboarding.svg',
    'Programs':          'programs.svg',
    'Logs':              'logs.svg',
    'SOSV Central':      'sosv-central.svg',
    'SOSV University':   'sosv-u.svg',
    'Startups':          'startups.svg',
    'Tableau':           'insights.svg',
    'Unchecked':         'checkbox.svg',
    'Wiki':              'wiki.svg',
    // Favorites
    'Company':           'startups.svg',
    'Contact':           'people.svg',
    'Form':              'forms.svg',
    'Insight':           'insights.svg',
    'Investor':          'investors.svg',
    'Program':           'programs.svg',
    'WikiPage':          'wiki.svg',
    // TODO: Convert to svg
    'Actions':           'fas fa-ellipsis-v',
    'ArrowDown':         'fas fa-arrow-down',
    'ArrowLeft':         'fas fa-arrow-left',
    'ArrowRight':        'fas fa-arrow-right',
    'ArrowUp':           'fas fa-arrow-up',
    // 'Favorite':        'far fa-star',
    // 'Favorited':       'fas fa-star',
    'Contract':          'fa fa-square-minus',
    'Expand':            'fa fa-square-plus',
    // Font Awesome 5 icons
    'AccountCategory':   'fas fa-building-columns',
    'Add':               'fas fa-plus',
    'Collections':       'fas fa-layer-group',
    'Admin':             'fas fa-cogs',
    'Alert':             'fas fa-triangle-exclamation',
    'Approve':           'fas fa-check',
    'Back':              'fas fa-chevron-left',
    'Bars':              'fas fa-bars',
    'Book':              'fas fa-book',
    'Calendar':          'far fa-calendar',
    'Cancel':            'fas fa-times',
    'Chart':             'fas fa-chart-line',
    'Checkmark':         'fas fa-check',
    'Circle':            'far fa-circle',
    'CircleCheck':       'far fa-circle-check',
    'CircleCross':       'far fa-circle-xmark',
    'Clear':             'fas fa-circle-xmark',
    'Clipboard':         'fas fa-clipboard',
    'Close':             'fas fa-times',
    'Cohort':            'fas fa-users',
    'Continue':          'fas fa-arrow-right',
    // 'Company':         'fas fa-industry',
    // 'Contact':         'fas fa-user',
    'CSV':               'fas fa-file-csv',
    'Delete':            'fas fa-trash',
    'Directory':         'fas fa-list',
    'Done':              'fas fa-circle-check',
    'Down':              'fas fa-angle-down',
    'Download':          'fas fa-download',
    'Edit':              'fas fa-edit',
    'Email':             'fas fa-envelope',
    'ExtLink':           'fas fa-external-link-alt',
    'Favorite':          'far fa-star',
    'Favorited':         'fas fa-star',
    'Favorites':         'fas fa-bookmark',
    'FavoritesO':        'far fa-bookmark',
    'File':              'fas fa-file',
    'FileDraft':         'fas fa-file-pen',
    'Filter':            'fas fa-filter',
    'Flag':              'fas fa-flag',
    'Folder':            'fas fa-folder',
    'FolderOpen':        'fas fa-folder-open',
    'Help':              'fas fa-circle-question',
    'Image':             'fas fa-image',
    'Images':            'fas fa-images',
    'Instagram':         'fab fa-instagram',
    'Scout':             'fas fa-wand-magic-sparkles',
    'Left':              'fas fa-angle-left',
    'Link':              'fas fa-link',
    'LinkBroken':        'fas fa-link-slash',
    'LinkedIn':          'fab fa-linkedin',
    'Map':               'fas fa-map-location-dot',
    'List':              'fas fa-list',
    'Minus':             'fas fa-circle-minus',
    'ListCompact':       'fas fa-bars',
    'Location':          'fas fa-location-dot',
    'Login':             'fas fa-sign-in-alt',
    'Logout':            'fas fa-right-from-bracket',
    'Move':              'fas fa-arrow-right-arrow-left',
    'Next':              'fas fa-circle-arrow-right',
    'Notifications':     'fas fa-triangle-exclamation',
    'NoNotifications':   'fas fa-bell-slash',
    'Prefs':             'fas fa-cog',
    'Process':           'fas fa-cog',
    // 'Program':          'fas fa-building-columns',
    'Question':          'fas fa-question',
    'Reorder':           'fas fa-bars',
    'Report':            'fas fa-chart-pie',
    'Right':             'fas fa-angle-right',
    'Robot':             'fas fa-robot',
    'Save':              'fas fa-save',
    'Search':            'fas fa-search',
    'Selection':         'fas fa-layer-group',
    'SelectionO':        'fas fa-layer-group',
    'Send':              'fas fa-paper-plane',
    'Skip':              'fas fa-forward',
    'Slides':            'fas fa-images',
    'Spin':              'fas fa-rotate-right',
    'Spinner':           'fas fa-spinner',
    'Sync':              'fas fa-rotate',
    'Tag':               'fas fa-tag',
    'Up':                'fas fa-angle-up',
    'Upload':            'fas fa-arrow-circle-up',
    'User':              'fas fa-user',
    'Users':             'fas fa-user-group',
    'View':              'fas fa-eye',
    'Wait':              'fas fa-circle-notch',
    'Warning':           'fas fa-triangle-exclamation',
    'Website':           'fas fa-globe',
    'WikiHome':          'fas fa-home',
    // Wiki Editor
    'Bold':              'fas fa-bold',
    'Italic':            'fas fa-italic',
    'Code':              'fas fa-code',
    'Strike':            'fas fa-strikethrough',
    'ClearMarks':        'fas fa-eraser',
    'Highlight':         'fas fa-highlighter',
    'CaretDown':         'fas fa-caret-down',
    'Paragraph':         'fas fa-paragraph',
    'Heading':           'fas fa-heading',
    'OrderedList':       'fas fa-list-ol',
    'BulletList':        'fas fa-list-ul',
    'CodeBlock':         'fas fa-code',
    'Blockquote':        'fas fa-quote-left',
    'HorizontalRule':    'fas fa-minus',
    'HardBreak':         'fas fa-arrow-left',
    'Source':            'fas fa-file-code',
    'Undo':              'fas fa-undo',
    'Redo':              'fas fa-redo'
  } as Record<string, string>

  // Return the icon or the question icon if not found
  if (icon && dictionary[icon]) {
    return dictionary[icon]
  } else {
    return dictionary['Question']
  }
}
